import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

const ANIMATION_TIMEOUT = 3500;

const blurProperty = gsap.utils.checkPrefix('filter');
const blurRegex = /blur\((.+)?px\)/;
const getBlurMatch = target => (gsap.getProperty(target, blurProperty) || '').match(blurRegex) || [];

gsap.registerPlugin({
  name: 'blur',

  get(target) {
    return +(getBlurMatch(target)[1]) || 0;
  },

  init(target, endValue) {
    let data = this;
    let filter = gsap.getProperty(target, blurProperty);
    let endBlur = 'blur(' + endValue + 'px)';
    let match = getBlurMatch(target)[0];
    let index;

    if (filter === 'none') {
      filter = '';
    }

    if (match) {
      index = filter.indexOf(match);
      endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
    } else {
      endValue = filter + endBlur;
      filter += filter ? ' blur(0px)' : 'blur(0px)';
    }
    data.target = target;
    data.interp = gsap.utils.interpolate(filter, endValue);
  },

  render(progress, data) {
    data.target.style[blurProperty] = data.interp(progress);
  }
});

const iconStates = [
  { left: '80%', opacity: 0.6, scale: 0.7, blur: 3 },
  { left: '20%', opacity: 0.6, scale: 0.7, blur: 3 },
  { left: '50%', opacity: 1.0, scale: 1.0, blur: 0 },
];

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        quizTrigger: 'openQuiz',
      },
    };

    this.iObs = null;
    this.timeoutID = null;
    this.counter = 0;
    this.isVisible = false;
  }

  init() {
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    if ( !window.IntersectionObserver ) {
      return;
    }

    this.iObs = new IntersectionObserver(entries => {
      entries.forEach((entry, self) => {
        if ( entry.isIntersecting ) {
          if (! this.isVisible) {
            this.runAnimation();
          } else {
            this.runIconsAnimation();
          }
        } else {
          this.stopAnimation();
        }
      });
    }, {
      threshold: [ 0.25 ],
    });

    this.iObs.observe( this.el );
  }

  runAnimation() {
    this.isVisible = true;

    gsap.to( this.el, {
      duration: 0.8,
      opacity: 1,
      x: 0,
      ease: 'power3.out',
      onComplete: () => {
        this.runIconsAnimation();
      }
    } );
  }

  runIconsAnimation() {
    this.doIconsAnimation();
  }

  stopAnimation() {
    if ( this.timeoutID ) {
      clearTimeout( this.timeoutID );
      this.timeoutID = null;
    }
  }

  doIconsAnimation() {
    gsap.to(this.$('solution')[0], {
      left: iconStates[ this.counter % 3 ].left
    });

    gsap.to(this.$('solution')[0].children[0], {
      opacity: iconStates[ this.counter % 3 ].opacity,
      scale: iconStates[ this.counter % 3 ].scale,
      blur: iconStates[ this.counter % 3 ].blur,
    })

    gsap.to(this.$('solution')[1], {
      left: iconStates[ (this.counter + 1) % 3 ].left
    });

    gsap.to(this.$('solution')[1].children[0], {
      opacity: iconStates[ (this.counter + 1) % 3 ].opacity,
      scale: iconStates[ (this.counter + 1) % 3 ].scale,
      blur: iconStates[ (this.counter + 1) % 3 ].blur,
    })

    gsap.to(this.$('solution')[2], {
      left: iconStates[ (this.counter + 2) % 3 ].left
    });

    gsap.to(this.$('solution')[2].children[0], {
      opacity: iconStates[ (this.counter + 2) % 3 ].opacity,
      scale: iconStates[ (this.counter + 2) % 3 ].scale,
      blur: iconStates[ (this.counter + 2) % 3 ].blur,
    });

    this.counter++;
    this.timeoutID = setTimeout(() => this.doIconsAnimation(), ANIMATION_TIMEOUT);
  }

  openQuiz() {
    this.call('open', 'generic', 'Quiz');
  }
}
